import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4bdmvim3s7: FaireBrandEntity = {
  token: "b_4bdmvim3s7",
  type: "brand",
  name: "MIOU MUSE",
  avatarUrl:
    "https://cdn.faire.com/fastly/6c28aa55e11ad1fabdbb1e83595b2517928e55ba8590e5bf6c087774b3bbdcb4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2563d2752e90c64b51d989ee1f58c0769e08bd6adce7cc8dbbb589374d417782.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6c28aa55e11ad1fabdbb1e83595b2517928e55ba8590e5bf6c087774b3bbdcb4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2563d2752e90c64b51d989ee1f58c0769e08bd6adce7cc8dbbb589374d417782.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 512,
  isTopShop: true,
  isInsider: true,
  description:
    "MIOU MUSE has been dedicated to styling the young contemporary girl since 2020. Our highly innovative, original, yet trendy designs keep every woman on the cutting edge of fashion. As a young contemporary brand, we continue to enjoy providing flirty yet confident styles to our fans worldwide.\n\nMIO simply stands for 'Mine' in Spanish and Muses come from Greek mythology. They were usually beautiful women that would give others inspiration. So if someone is your muse, they give you inspiration and you may call them beautiful as well.\n\nWe proudly recommend our style as an art of self-expression and wish every woman be a proud member of society in their field.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:39.109Z",
    importedBy: "entity-db-cli",
  },
};
